import MojitoCore from 'mojito/core';
import PrebuiltBetBuilderLeagueImpl from './pre-built-bet-builder-league.js';

const { UIPage } = MojitoCore.Presentation;

/**
 * @namespace PrebuiltBetBuilderLeague
 * @memberof Mojito.Applications.Sports.Pages
 */

export default UIPage('PrebuiltBetBuilderLeague', PrebuiltBetBuilderLeagueImpl);
